import React, {useEffect} from 'react'
import {useLocation} from 'react-router'
import {PATH_MAILING} from '../../../routing/paths'
import {initialValueMailing, useStorage} from '../../../@contexts'
import {NavLinkInterface, NavLinksHeader} from '../../../@components'

const navLinks: NavLinkInterface[] = [
  { path: PATH_MAILING.campaigns.root, label: 'Toutes' },
  {
    path: PATH_MAILING.campaigns.favorites,
    label: 'Favoris',
    iconPath: '/media/icons/duotune/general/gen029.svg',
    iconClass: 'svg-icon-4 svg-icon-warning'
  },
  { path: PATH_MAILING.campaigns.drafts, label: 'Brouillons' },
  { path: PATH_MAILING.campaigns.scheduled, label: 'Programmées' },
  { path: PATH_MAILING.campaigns.sent, label: 'Envoyées' },
  {
    path: PATH_MAILING.campaigns.Archived,
    label: 'Archivées',
    iconPath: '/media/icons/duotune/files/fil017.svg',
    iconClass: 'svg-icon-4 svg-icon-success'
  },
];

const CampaignsHeader = () => {

  const location = useLocation()
  const {setMailing} = useStorage()

  useEffect(() => {
    setMailing(initialValueMailing)
  }, [setMailing])

  return (
    <NavLinksHeader navLinks={navLinks} pathname={location.pathname} />
  )
}

export {CampaignsHeader}